(function(){
'use strict';
var H=window.FT_GS_H;if(!H)return;
var D=H.D,fmt=H.fmt,COLL=H.COLL;
function calc(cart){
var u=[];
(cart.items||[]).forEach(function(it){var p=D[it.handle];if(!p)return;for(var i=0;i<it.quantity;i++)u.push({p:p,h:it.handle});});
u.sort(function(a,b){return b.p-a.p;});
var free=[],saved=0;
for(var k=1;k<u.length;k+=2){free.push(u[k]);saved+=u[k].p;}
return {n:u.length,free:free,saved:saved};
}
function nudge(r,saved){
if(r.n===0)return null;
if(r.n%2===1)return {h:r.n===1?'ADD A SECOND PIECE, FREE':'ONE MORE PIECE, FREE',b:'Add another piece from the collection and it comes off at checkout.',a:'Pick a second piece →'};
if(saved>0)return {h:'FREE PIECE APPLIED',b:'You are saving '+fmt(saved)+' at checkout.',a:null};
return null;
}
function put(w,n){if(!w||!n)return;if(w.querySelector('[data-gs-n]'))return;
var d=document.createElement('div');d.className='gs-cart';d.setAttribute('data-gs-n','1');
d.innerHTML='<div class="h">'+n.h+'</div><div>'+n.b+'</div>'+(n.a?'<div style="margin-top:8px"><a href="'+COLL+'">'+n.a+'</a></div>':'');
w.insertBefore(d,w.firstChild);}
function mark(r){
var want={};r.free.forEach(function(t){want[t.h]=(want[t.h]||0)+1;});
document.querySelectorAll('line-item,.ft-drawer-line-item,.cart-item,[class*="line-item"]').forEach(function(row){
if(row.querySelector('[data-gs-f]'))return;
if(row.querySelector('line-item,.ft-drawer-line-item'))return;
var a=row.querySelector('a[href*="/products/"]');if(!a)return;
var m=a.getAttribute('href').split('?')[0].match(/\/products\/([^\/]+)/);if(!m||!want[m[1]])return;
want[m[1]]--;
var t=row.querySelector('.ft-drawer-line-item__title,[class*="__title"],a[href*="/products/"]');
if(t){var s=document.createElement('span');s.className='gs-free';s.setAttribute('data-gs-f','1');s.textContent='FREE';t.appendChild(s);}
});}
function paint(){
fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
var realSaved=(cart.total_discount||0)/100;
var r=calc(cart),n=nudge(r,realSaved);
document.querySelectorAll('[data-gs-n],[data-gs-f],[data-gs-s]').forEach(function(e){e.remove();});
put(document.querySelector('form.ft-cart__items')||document.querySelector('.ft-cart__items'),n);
put(document.querySelector('.cart-drawer__body-content'),n);
mark(r);
if(realSaved>0){var s=document.querySelector('.ft-cart__summary');
if(s){var d=document.createElement('div');d.setAttribute('data-gs-s','1');
d.style.cssText='font:600 12px/1.4 ui-monospace,monospace;color:#1E7A4B;margin:8px 0';
d.textContent='Offer saving at checkout: −'+fmt(realSaved);s.insertBefore(d,s.firstChild);}}
}).catch(function(){});
}
var _f=window.fetch;
window.fetch=function(){var a=arguments,p=_f.apply(this,a);
try{var u=(typeof a[0]==='string')?a[0]:(a[0]&&a[0].url)||'';
if(/\/cart\/(add|change|update|clear)/.test(u))p.then(function(){setTimeout(paint,350);});}catch(e){}
return p;};
document.addEventListener('DOMContentLoaded',function(){setTimeout(paint,400);});
setTimeout(paint,900);
var mo=new MutationObserver(function(){clearTimeout(window.__gsC);window.__gsC=setTimeout(paint,400);});
if(document.body)mo.observe(document.body,{childList:true,subtree:true});
})();
